
import { Button, Checkbox, FormControlLabel, FormHelperText, Grid, Typography } from "@mui/material";
import style from "../styles/_externalUser.module.scss";
import { CustomFileUploader, SpinnerText } from "shared/components";
import { useFormExternal } from "../hook";
import { IFieldFormExternal, validationSchemaForm } from "../helper";
import { Form, Formik } from "formik";
import ReCAPTCHA from 'react-google-recaptcha'
import { ExitToApp } from "@mui/icons-material";
import { SpinnerLoading } from "shared/components/SpinnerLoading";

export const FormExternal = () => {
    const {
        dataFields,
        initialValues,
        submitHandler,
        onChangeReCaptcha,
        formikRef,
        handleChangeFile,
        recaptchaRef,
        isButtonDisabled,
        dispatch,
        isLoading,
        resolution3374Document,
        originalName,
        setResolution3374Document,
        onLogout,
        dataEmployees
    } = useFormExternal();

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={initialValues}
                validationSchema={validationSchemaForm}
                onSubmit={submitHandler}
                enableReinitialize
                validateOnBlur={true}
                validateOnChange={false}
                validateOnMount={false}
            >
                {  
                    formik =>  (
                        <Form className={`${style.containerFormDocument} form-documents`} data-testid="form-read-documents">
                            <Grid container className={style.gridContainer}>
                                {
                                dataFields.map((field: IFieldFormExternal, index) => (
                                    <Grid item xs={12} md={6} lg={6} key={field.id} sx={{padding: "0 5px 10px"}}> 
                                    {
                                        field.type === "select" &&
                                        <section className="itemForm">
                                            <label style={{zIndex: "0"}} htmlFor={field.id} className="text-required">
                                            {field.label}
                                            </label>
                                            <select 
                                                name={field.name}
                                                id={field.id}
                                                data-testid={field.testId}
                                                value={formik.values[field.id]}
                                                onChange={formik.handleChange}
                                                className={formik.errors[field.id] && formik.touched[field.id] ? "itemForm errorCampoSelect" : "itemForm"}
                                                onBlur={formik.handleBlur}
                                            >
                                            <option value="" disabled hidden> {field.placeholder}</option>
                                            {
                                                field?.options?.map((opcion: any) => (
                                                <option key={opcion.id + index} value={opcion.id}>
                                                    {opcion.name}
                                                </option>
                                                ))
                                            }
                                            </select>
                                            <FormHelperText style={{ color: "red", fontSize: "12px" }}>
                                                <>
                                                    {formik.touched[field.id]   && formik.errors[field.id] 
                                                    ? formik.touched[field.id] && formik.errors[field.id] 
                                                    : " "}
                                                </>
                                            </FormHelperText>

                                        </section>
                                    }
                                    {
                                        field.type === "text" &&
                                            <section className="itemForm" >
                                                <label style={{zIndex: "0"}} htmlFor={field.id} className="text-required">
                                                    {field.label}
                                                </label>
                                                <input 
                                                    name={field.name}
                                                    placeholder={field.placeholder}
                                                    id={field.id}
                                                    data-testid={field.testId}
                                                    value={ formik.values.codeDane }
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    className={formik.errors.codeDane && formik.touched.codeDane ? "itemForm errorCampoSelect" : "itemForm"}
                                                />
                                                <FormHelperText style={{ color: "red", fontSize: "12px" }}>
                                                    <>
                                                        {formik.touched.codeDane && formik.errors.codeDane
                                                        ? formik.touched.codeDane && formik.errors.codeDane
                                                        : " "}
                                                    </>
                                                </FormHelperText>
                                            </section>
                                    }
                                    </Grid>
                                ))
                                }
                                <Grid item xs={12} sx={{ margin: "10px 0", display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                                    <CustomFileUploader
                                        fileLength={20}
                                        originalName={originalName}
                                        typeAccept={["ZIP"]}
                                        document={resolution3374Document}
                                        handleChangeFile={(file) => {
                                            handleChangeFile(file, formik)
                                        }}
                                        removeFile={() => {
                                            formik.setFieldValue("resolution3374Document", null)
                                            dispatch.linkDocument.cleanAllState();
                                            setResolution3374Document(null);
                                        }} 
                                    />
                                    <FormHelperText style={{ color: "red", fontSize: "12px" }}>
                                        <>
                                            {!formik.values?.resolution3374Document?.name && formik.errors.resolution3374Document}
                                        </>
                                    </FormHelperText>
                                </Grid>
                                <Grid container gap={2} margin={"1.5rem 0 0 0"} >
                                    <Typography className={style.subtitle}>INFORMACIÓN BASICA DE  FUNCIONARIO RESPONSABLE DE RIPS</Typography>
                                </Grid>
                                {
                                    dataEmployees.map((field: IFieldFormExternal, index) => (
                                        <Grid item xs={12} md={6} lg={6} key={field.id} sx={{padding: "0 5px 10px"}}>
                                            <section className="itemForm" >
                                                <label style={{zIndex: "0"}} htmlFor={field.id} className="text-required">
                                                    {field.label}
                                                </label>
                                                <input 
                                                    name={field.name}
                                                    placeholder={field.placeholder}
                                                    id={field.id}
                                                    data-testid={field.testId}
                                                    value={formik.values[field.id]}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    className={formik.errors[field.id] && formik.touched[field.id] ? "itemForm errorCampoSelect" : "itemForm"}
                                                />
                                                <FormHelperText style={{ color: "red", fontSize: "12px" }}>
                                                    <>
                                                        {formik.touched[field.id]   && formik.errors[field.id] 
                                                        ? formik.touched[field.id] && formik.errors[field.id] 
                                                        : " "}
                                                    </>
                                                </FormHelperText>
                                            </section>
                                        </Grid>
                                    ))
                                }
                                <section  className={style.contentDescription}>
                                    <Typography className={style.textPolicy}>
                                        El presente FORMULARIO tiene como finalidad Monitorear el Reporte de los Registros Individuales de Prestación de Servicios de Salud (RIPS - Generales) que deben enviar las Direcciones Locales de Salud a mas tardar el día 15 de cada mes a la SSSA, la información aquí recopilada es de carácter confidencial y con fines académicos. En cumplimiento de la Ley 1581 de 2012 es interés de la Gobernación de Antioquia salvaguardar la privacidad de la información personal de la ciudadanía obtenida a través de cualquiera de los tres canales habilitados por la misma; virtual, telefónico y/o presencial. El ciudadano acepta que a través del registro, la Gobernación recolecta, almacena, usa, circula, transfiere y administra datos personales como nombre, identificación, edad, género, dirección, correo electrónico y teléfono; los cuales serán utilizados exclusivamente en cumplimiento de la misión de la entidad, dichos datos no se cederán a terceros sin su consentimiento.
                                    </Typography>

                                    <FormControlLabel
                                        className={style.checkboxContainer}
                                        classes={{ label: style.checkboxLabelContainer }}
                                        control={
                                            <Checkbox
                                                className={style.checkbox}
                                                checked={formik.values.termsOfService}
                                                data-testid="input-check-accept"
                                                name="termsOfService"
                                                onChange={(e) => {
                                                    formik.setFieldValue("termsOfService", e.target.checked);
                                                }}
                                                id="termsOfService"
                                            />
                                        }
                                        label={<span className={style.checkboxLabel}>Aceptar términos y condiciones.</span>}
                                    />
                                    <FormHelperText style={{ color: "red", fontSize: "12px" }}>
                                        <>
                                            {!formik.values.termsOfService && formik.errors.termsOfService}
                                        </>
                                    </FormHelperText>
                                    <section className={style.recaptcha}>
                                        <ReCAPTCHA
                                            sitekey='6LeR35oqAAAAAHqztXjqqmuPU9LCXhVYfPbrpSo3'
                                            onChange={onChangeReCaptcha}
                                            ref={recaptchaRef}
                                        />
                                    </section>
                                </section>
                            </Grid>
                            <section className={style.contentButton}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={style.buttonRips}
                                    data-testid="button_save"
                                    type="submit"
                                    id="button_save"
                                    disabled={isButtonDisabled}
                                >
                                    Cargar Rips
                                </Button>
                                <Button
                                    className='fs-9'
                                    variant='outlined' 
                                    startIcon={<ExitToApp/>}
                                    aria-label="btn-logout"
                                    onClick={onLogout}
                                    data-testid='btn_logout'
                                >
                                    Cerrar sesión
                                </Button>
                            </section>
                        </Form>
                    )
                }
            </Formik>
            {(isLoading) && <SpinnerLoading/>}
        </>
    )
}
